// extracted by mini-css-extract-plugin
export default {"page-title-container":"oVSLpAhuaNTb89r8fmon","title-container":"KNpuE2lu4L_z4tdYklBh","title-left-section":"ydbtBXeh0iNqjkWR76vQ","description-wrapper":"spzs9ABIdUCpHu_wVZvq"};